import {
  isRouteErrorResponse,
  Link,
  useRouteError,
} from "react-router-dom";
import usePageTitle from "../hooks/usePageTitle";

function NotFoundPage() {
  const error = useRouteError();
  const status = isRouteErrorResponse(error) ? error.status : 404;
  const message = isRouteErrorResponse(error)
    ? error.statusText
    : "The page you are looking for could not be found.";

  usePageTitle(`${status} | Pargro`);

  return (
    <main className="flex min-h-screen items-center justify-center bg-[#f4f7fb] px-6">
      <section className="w-full max-w-[620px] rounded-[9px] bg-white px-10 py-12 text-center shadow-[0_3px_13px_rgba(15,23,42,0.16)]">
        <p className="mb-2 text-[1.2rem] font-bold text-[#0d73ff]">
          Error {status}
        </p>
        <h1 className="mb-4 text-[2.4rem] font-extrabold text-[#062f58]">
          Page Not Found
        </h1>
        <p className="mb-8 text-[1.2rem] leading-7 text-[#3f4751]">
          {message}
        </p>
        <Link
          className="inline-flex rounded-[28px] bg-[#1773f8] px-8 py-3 text-[1.2rem] font-bold text-white no-underline transition hover:bg-[#0d63dc] focus-visible:bg-[#0d63dc]"
          to="/"
        >
          Go Home
        </Link>
      </section>
    </main>
  );
}

export default NotFoundPage;
